import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ManageCognitoUser from './ManageCognitoUser';
import CognitoReport from './CognitoReport';
import AutoLoginLink from './AutoLoginLink';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={1}>{children}</Box>}
        </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

export default function Landing() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div style={{ marginLeft: '40%', marginTop: 20 }}>
        <div className={classes.root} style={{ padding: '2%', width: '830px', marginTop: '0%' }}>
            <AppBar position="static" style={{ background: 'rgb(51,175,176)' }}>
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                    <Tab label="Resend Email" {...a11yProps(0)} />
                    <Tab label="Cognito Report" {...a11yProps(1)} />
                    <Tab label="Autologin Link" {...a11yProps(2)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <ManageCognitoUser />
            </TabPanel>
            <TabPanel value={value} index={1}>
               <CognitoReport/>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <AutoLoginLink />
            </TabPanel>
        </div>
        </div>
    );
}